module.exports = __webpack_public_path__ + "static/media/temp_pressure_gauge.0cb47a67.png";